export default __webpack_public_path__ + "static/media/arrow.c7a97e9c.svg";